import { useGoogleMap } from '@react-google-maps/api';
import React from 'react';

import { StyledMapIcon, StyledPressedMapIcon, StyledPressedSatelliteIcon, StyledSatelliteIcon } from './styles';
import { ControlPaper } from '../styles';
import { MapTypeControlProps, MapType } from './types';

const MapTypeControl: React.FunctionComponent<MapTypeControlProps> = ({
  onClick,
  ...props
}): React.ReactElement | null => {
  const map = useGoogleMap();
  const [mapType, setMapType] = React.useState<MapType | null>(map && (map.getMapTypeId() as unknown as MapType));

  const changeMapType = React.useCallback(
    (value: MapType) => {
      map?.setMapTypeId(value as unknown as string);
      setMapType(value);
    },
    [map]
  );

  if (!map) {
    return null;
  }

  return (
    <ControlPaper elevation={6} {...props}>
      {mapType === MapType.ROADMAP ? (
        <StyledPressedMapIcon data-testid="pressed-map" />
      ) : (
        <StyledMapIcon data-testid="map" onClick={() => changeMapType(MapType.ROADMAP)} />
      )}

      {mapType === MapType.SATELLITE ? (
        <StyledPressedSatelliteIcon data-testid="pressed-satellite" />
      ) : (
        <StyledSatelliteIcon data-testid="satellite" onClick={() => changeMapType(MapType.SATELLITE)} />
      )}
    </ControlPaper>
  );
};

export default MapTypeControl;
